import { render } from "./MvMainText.vue?vue&type=template&id=2131c3a8"
import script from "./MvMainText.vue?vue&type=script&lang=js"
export * from "./MvMainText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__